import { BaseDeclarationTable, DeclarationTableContext } from '@modules/declarations';

export const FlightDeclarationsTable = () => {
  return <BaseDeclarationTable context={DeclarationTableContext} />;
};
